import React from "react";
import { Link } from "react-router-dom";
import { BLOG_POSTS } from "../../content/siteContent";

const formatDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const BlogPageSidebar = () => {
  const posts = [...BLOG_POSTS].sort(
    (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
  );

  const categories = Object.values(
    posts.reduce((acc, post) => {
      acc[post.category] = acc[post.category] || { label: post.category, value: 0 };
      acc[post.category].value += 1;
      return acc;
    }, {})
  );

  const recentPosts = posts.slice(0, 3);

  const tags = Array.from(new Set(posts.flatMap((post) => post.tags))).slice(
    0,
    12
  );

  return (
    <aside className="blog-sidebar">
      {/* Categories */}
      <div className="blog-widget">
        <h4 className="bw-title">Categories</h4>

        <div className="bs-cat-list">
          <ul className="list-wrap">
            {categories.map((cat, idx) => (
              <li key={idx}>
                <Link to={`/blog?category=${encodeURIComponent(cat.label)}`}>
                  {cat.label} <span>({cat.value})</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* recents */}
      <div className="blog-widget">
        <h4 className="bw-title">Recent Posts</h4>

        <div className="rc-post-wrap">
          {recentPosts.map((post) => (
            <div key={post.id} className="rc-post-item">
              <div className="thumb">
                <Link to={`/blog/${post.slug}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/services-details/${post.image}`}
                    alt={post.imageAlt}
                  />
                </Link>
              </div>
              <div className="content">
                <span className="date">
                  <i className="far fa-calendar"></i>
                  {formatDate(post.publishDate)}
                </span>
                <h2 className="title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* tags */}
      <div className="blog-widget">
        <h4 className="bw-title">Tags</h4>

        <div className="bs-tag-list">
          <ul className="list-wrap">
            {tags.map((item) => (
              <li key={item}>
                <Link to={`/blog?tag=${encodeURIComponent(item)}`}>{item}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
};

